/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-globals */

'use-strict';

import angular, { ILocationService, IScope, ITimeoutService } from 'angular';
import { RootScope } from '../../app.config';
import OnboardingComponent from '../../src/app/onboarding/onboarding.component';

/* @ngInject */
export class InterfaceService {
  private $location: ILocationService;

  private $rootScope: RootScope;

  private $timeout: ITimeoutService;

  private onboardingComponent?: OnboardingComponent;

  constructor(
    $location: ILocationService,
    $rootScope: RootScope,
    $timeout: ITimeoutService,
  ) {
    'ngInject';

    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;

    this.$rootScope.pageLoadComplete = false;
    this.$rootScope.onBoardingScreen = false;
    this.$rootScope.showChangelog = false;
    this.$rootScope.showOfflineBanner = false;

    window.addEventListener('offline', () => {
      this.showOfflineBanner();
    });

    window.addEventListener('online', () => {
      this.hideOfflineBanner();
    });

    this.$rootScope.VERSION_NUMBER = VERSION_NUMBER;
    this.$rootScope.BUILD_NUMBER = BUILD_NUMBER;
  }

  public registerOnboardingComponent = (c: OnboardingComponent): void => {
    this.onboardingComponent = c;
  };

  public pwaIsInstalled = (): boolean => window.matchMedia('(display-mode: standalone)').matches;

  public pwaIsInstallable = (): boolean => {
    if (this.onboardingComponent) return this.onboardingComponent.pwaIsInstallable();
    return false;
  };

  public showPwaInstallBanner = (): void => {
    if (this.onboardingComponent) this.onboardingComponent.showPwaDialog();
  };

  public showOfflineBanner = (): void => {
    this.$rootScope.showOfflineBanner = true;
    this.applyScope(this.$rootScope);
  };

  public hideOfflineBanner = (): void => {
    this.$rootScope.showOfflineBanner = false;
    this.applyScope(this.$rootScope);
  };

  /** Force save digest cycle by calling $apply method from supplied scope. */
  public applyScope = (scope: IScope): void => {
    this.$timeout(() => {
      scope.$apply(() => {});
    });
  };

  public clearNavTitle = (): void => {
    this.setNavTitle('');
  };

  public showOnboardingScreen = (): void => {
    if (this.onboardingComponent) {
      this.onboardingComponent.showNotificationsOnboarding();
    }

    this.$timeout(() => {
      this.$rootScope.onBoardingScreen = true;
    }, 0);
  };

  public hideOnboadingScreen = (): void => {
    this.$timeout(() => {
      this.$rootScope.onBoardingScreen = false;
    }, 0);
  };

  public setNavTitle = (title: string): void => {
    this.$rootScope.navTitle = title;
  };

  public hidePagePreloader = (): void => {
    this.$rootScope.pageLoadComplete = true;
  };

  public toggleBodyOverflow = (toggle: boolean): void => {
    this.$rootScope.bodyOverFlowHide = toggle;
  };

  public showUpdateBanner = (): void => {
    this.$rootScope.$apply(() => {
      this.$rootScope.showUpdateBanner = true;
    });
  };

  public updateBannerHandler = (): void => {
    window.location.reload();
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  public toggleChangelog = (): void => {
    this.$rootScope.showChangelog = !this.$rootScope.showChangelog;
  };

  public navigateToUrl = (url: string, params?: { [key: string]: unknown }): void => {
    if (params) {
      this.$location.path(url).search(params);
    } else {
      this.$location.path(url);
    }
  };

  public getRouteParams = (): { [key: string]: string } => this.$location.search();

  public getPath = (): string => this.$location.path();

  public toggleNotificationDrawer = (): void => {
    this.$rootScope.showNavigationDrawer = !this.$rootScope.showNavigationDrawer;
  };
}

export default angular
  .module('services.interface', [])
  .service('interfaceService', InterfaceService)
  .name;
